import { render } from "./ModalVacaciones.vue?vue&type=template&id=cd9a73ea"
import script from "./ModalVacaciones.vue?vue&type=script&lang=js"
export * from "./ModalVacaciones.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__